/*
  h26-pdp.js: behaviour for the Harvest 2026 single product page (h26-pdp-* sections).
  Loaded by sections/h26-pdp-main.liquid. Idempotent; never throws to the page.
  - gallery: thumbnails, swipe sync, tap to zoom (Escape closes, focus returns)
  - jump links: rating -> reviews, Details -> pre-order terms (opens the row)
  - farmer story: Read more expands inline (phones); the event fires on open only
  - carousels: arrows, "1-2 of 5" range count, recalculated on resize; oo_carousel_move
  - last year's reviews: Read all side panel, Judge.me widget endpoint (b), filters, Load more;
    keeps the server-rendered reviews (c) if the endpoint fails
  - sticky add to cart: shown once the main buy box has scrolled away; oo_sticky_shown once
  - Notify me: opens the Klaviyo form named in the block setting
  - subscribe switch (buy box, only when the variant has selling plans): on = the selected plan
    goes into every selling_plan input on the page (main + sticky forms; h26-atc.js posts it),
    the main and sticky prices show the plan price (never struck through), the free-shipping gap
    is recomputed from the plan price (server-rendered per plan; converted-currency lines are
    re-run through window.H26Thr). Off = all back to one-time. oo_subscribe_toggle {state, target}
  Add to cart itself is assets/h26-atc.js (form[data-h26-atc]); events are assets/h26-events.js.
*/
(function () {
  'use strict';
  if (window.__h26pdp) return;
  window.__h26pdp = true;

  function track(name, fields, el) {
    try { if (window.OOH26 && window.OOH26.track) window.OOH26.track(name, fields || null, el || null); } catch (e) {}
  }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return [].slice.call((root || document).querySelectorAll(sel)); }
  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  function scrollToEl(el) {
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
  }

  /* ---------- gallery + zoom ---------- */
  function initGallery() {
    $$('[data-h26-gallery]').forEach(function (g) {
      if (g.__h26) return; g.__h26 = true;
      var track = $('[data-h26-track]', g);
      if (!track) return;
      var thumbs = $$('.h26p-thumbs button', g);
      var cur = 0;
      function mark(i) { thumbs.forEach(function (t, k) { t.setAttribute('aria-current', String(k === i)); }); }
      thumbs.forEach(function (b) {
        b.addEventListener('click', function () {
          var i = +b.getAttribute('data-i');
          cur = i; mark(i);
          track.scrollTo({ left: track.clientWidth * i, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== cur) { cur = i; mark(i); }
      }, { passive: true });
      var zoom = $('[data-h26-zoom]');
      if (!zoom) return;
      var zimg = $('[data-h26-zoom-img]', zoom);
      var closeBtn = $('[data-h26-zoom-close]', zoom);
      var ret = null;
      function close() {
        zoom.classList.remove('is-open'); zoom.hidden = true;
        document.documentElement.style.overflow = '';
        if (ret && ret.focus) ret.focus();
      }
      $$('.h26p-slide', track).forEach(function (s) {
        s.addEventListener('click', function () {
          var img = $('img', s);
          if (!img) return;
          var src = img.currentSrc || img.src;
          var ss = img.getAttribute('srcset');
          if (ss) { var parts = ss.split(','); src = parts[parts.length - 1].trim().split(' ')[0] || src; }
          zimg.src = src; zimg.alt = img.alt || '';
          ret = s;
          zoom.hidden = false; zoom.classList.add('is-open');
          document.documentElement.style.overflow = 'hidden';
          closeBtn.focus();
        });
      });
      closeBtn.addEventListener('click', close);
      zoom.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
        if (e.key === 'Tab') { e.preventDefault(); closeBtn.focus(); }
      });
    });
  }

  /* ---------- jump links ---------- */
  function initJumps() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-h26-jump]');
      if (!a) return;
      var kind = a.getAttribute('data-h26-jump');
      var t = null;
      if (kind === 'reviews') t = document.getElementById('h26-reviews') || $('[data-h26-reviews-native]');
      if (kind === 'policy') { t = document.getElementById('h26p-policy'); if (t && t.tagName === 'DETAILS') t.open = true; }
      if (!t) return;
      e.preventDefault();
      scrollToEl(t);
    });
  }

  /* ---------- farmer: Read more ---------- */
  function initFarmer() {
    $$('[data-h26-fmore]').forEach(function (b) {
      if (b.__h26) return; b.__h26 = true;
      var bio = document.getElementById(b.getAttribute('aria-controls'));
      if (!bio) return;
      var ev = b.getAttribute('data-h26-event');
      function needed() {
        if (!bio.classList.contains('is-clamped')) return true;
        return bio.scrollHeight > bio.clientHeight + 2;
      }
      function sync() { if (b.getAttribute('aria-expanded') !== 'true') b.hidden = !needed(); }
      sync();
      window.addEventListener('resize', sync, { passive: true });
      b.addEventListener('click', function () {
        var open = b.getAttribute('aria-expanded') !== 'true';
        bio.classList.toggle('is-clamped', !open);
        b.setAttribute('aria-expanded', String(open));
        b.textContent = open ? b.getAttribute('data-less') : b.getAttribute('data-more');
        // the click event fires on open only: drop the attribute while open, restore on close
        setTimeout(function () { if (open) b.removeAttribute('data-h26-event'); else if (ev) b.setAttribute('data-h26-event', ev); }, 0);
      });
    });
  }

  /* ---------- carousels ---------- */
  function initCarousel(c) {
    if (c.__h26car) return;
    var t = $('[data-h26-track-car]', c);
    var arw = $('[data-h26-arw]', c);
    if (!t || !arw) return;
    c.__h26car = true;
    var prev = $('[data-dir="-1"]', arw), next = $('[data-dir="1"]', arw), pos = $('.pos', arw);
    var of = (pos && pos.getAttribute('data-of')) || 'of';
    var name = t.getAttribute('data-h26-carousel') || '';
    var lastIdx = 1, byArrow = false, settle = null;
    function step() { var f = t.firstElementChild; return f ? f.getBoundingClientRect().width + 12 : t.clientWidth; }
    function upd() {
      var n = t.children.length;
      var over = t.scrollWidth > t.clientWidth + 4;
      arw.style.display = over ? '' : 'none';
      if (!over) return;
      var w = step();
      var vis = Math.max(1, Math.floor((t.clientWidth + 12) / w + 0.02));
      var i = Math.min(n, Math.round(t.scrollLeft / w) + 1);
      var atEnd = t.scrollLeft + t.clientWidth >= t.scrollWidth - 4;
      var last = Math.min(n, i + vis - 1);
      if (atEnd) { last = n; i = Math.max(1, n - vis + 1); }
      if (pos) pos.textContent = (i === last ? i : i + '-' + last) + ' ' + of + ' ' + n;
      prev.disabled = t.scrollLeft < 4;
      next.disabled = atEnd;
      return i;
    }
    function moved() {
      var i = upd();
      if (i && i !== lastIdx) {
        track('carousel_move', { carousel: name, method: byArrow ? 'arrow' : 'swipe', from: lastIdx, to: i }, c);
        lastIdx = i;
      }
      byArrow = false;
    }
    [prev, next].forEach(function (b) {
      b.addEventListener('click', function () {
        byArrow = true;
        t.scrollBy({ left: (+b.getAttribute('data-dir')) * step(), behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    t.addEventListener('scroll', function () { upd(); clearTimeout(settle); settle = setTimeout(moved, 160); }, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(upd).observe(t); else window.addEventListener('resize', upd);
    upd();
  }
  function initCarousels() { $$('[data-h26-car]').forEach(initCarousel); }

  /* ---------- last year's reviews: panel ---------- */
  function revCard(r, verifiedLabel) {
    var a = document.createElement('article');
    a.className = 'h26p-rcard';
    var st = document.createElement('span');
    st.className = 'h26p-stars';
    st.setAttribute('role', 'img');
    st.setAttribute('aria-label', r.score + ' / 5');
    for (var i = 1; i <= 5; i++) {
      var s = document.createElement('span');
      s.textContent = '★';
      if (i > r.score) s.className = 'off';
      st.appendChild(s);
    }
    a.appendChild(st);
    if (r.title) { var b = document.createElement('b'); b.textContent = r.title; a.appendChild(b); }
    if (r.body) { var p = document.createElement('p'); p.className = 'rb'; p.textContent = r.body; a.appendChild(p); }
    var c = document.createElement('cite');
    var bits = [r.author];
    if (r.verified && verifiedLabel) bits.push(verifiedLabel);
    if (r.date) bits.push(r.date);
    c.textContent = bits.filter(Boolean).join(' · ');
    a.appendChild(c);
    a.setAttribute('data-score', String(r.score));
    return a;
  }
  function fmtDate(iso) {
    try { var d = new Date(iso); if (isNaN(d)) return ''; return d.toLocaleDateString('en', { month: 'short', year: 'numeric', timeZone: 'UTC' }); } catch (e) { return ''; }
  }
  function parseWidget(html) {
    var out = [];
    try {
      var doc = new DOMParser().parseFromString(String(html || ''), 'text/html');
      $$('.jdgm-rev', doc).forEach(function (n) {
        var rt = $('.jdgm-rev__rating', n), tm = $('.jdgm-rev__timestamp', n);
        var txt = function (sel) { var x = $(sel, n); return x ? x.textContent.replace(/\s+/g, ' ').trim() : ''; };
        out.push({
          id: n.getAttribute('data-review-id') || '',
          score: rt ? (+rt.getAttribute('data-score') || 0) : 0,
          date: tm ? fmtDate(tm.getAttribute('datetime')) : '',
          author: txt('.jdgm-rev__author'),
          title: txt('.jdgm-rev__title'),
          body: txt('.jdgm-rev__body'),
          verified: n.getAttribute('data-verified-buyer') === 'true'
        });
      });
    } catch (e) {}
    return out;
  }
  function initReviews() {
    $$('[data-h26-lyr]').forEach(function (root) {
      if (root.__h26) return; root.__h26 = true;
      var openBtn = $('[data-h26-lyr-open]', root);
      var tpl = $('template[data-h26-lyr-panel]', root);
      if (!openBtn || !tpl) return;
      var shop = root.getAttribute('data-shop'), pid = root.getAttribute('data-source-id');
      var per = Math.min(25, Math.max(5, +root.getAttribute('data-per-page') || 10));
      var total = +root.getAttribute('data-count') || 0;
      var verified = root.getAttribute('data-verified') || '';
      var state = { items: [], seen: {}, page: 0, filter: 'all', done: false, failed: false, loading: false };
      var nodes = null, ret = null;

      function firstView() {
        return $$('[data-h26-lyr-first] .h26p-rcard', root).map(function (a) { return a.cloneNode(true); });
      }
      function paint() {
        if (!nodes) return;
        var list = nodes.list;
        list.innerHTML = '';
        var shown = 0;
        if (state.failed && !state.items.length) {
          firstView().forEach(function (a) {
            var sc = +a.getAttribute('data-score') || 0;
            if (state.filter === '5' && sc !== 5) return;
            if (state.filter === 'crit' && sc > 3) return;
            list.appendChild(a); shown++;
          });
        } else {
          state.items.forEach(function (r) {
            if (state.filter === '5' && r.score !== 5) return;
            if (state.filter === 'crit' && r.score > 3) return;
            list.appendChild(revCard(r, verified)); shown++;
          });
        }
        nodes.empty.hidden = shown > 0 || state.loading || (!state.done && !state.failed);
        nodes.fail.hidden = !state.failed;
        nodes.more.hidden = state.done || state.failed;
        if (state.loading) { var p = document.createElement('p'); p.className = 'h26p-pnote'; p.textContent = nodes.loadingText; list.appendChild(p); }
      }
      function load() {
        if (state.loading || state.done) return;
        state.loading = true; paint();
        var page = state.page + 1;
        var url = 'https://api.judge.me/reviews/reviews_for_widget?shop_domain=' + encodeURIComponent(shop) +
          '&platform=shopify&product_id=' + encodeURIComponent(pid) + '&page=' + page + '&per_page=' + per;
        fetch(url, { method: 'GET', credentials: 'omit' }).then(function (r) {
          if (!r.ok) throw new Error('http ' + r.status);
          return r.json();
        }).then(function (j) {
          var got = parseWidget(j && j.html);
          got.forEach(function (x) { if (x.id && state.seen[x.id]) return; if (x.id) state.seen[x.id] = 1; state.items.push(x); });
          state.page = page;
          var tc = j && +j.total_count;
          if (tc) total = tc;
          if (!got.length || state.items.length >= total) state.done = true;
        }).catch(function () {
          state.failed = true;
          track('reviews_load_result', { outcome: 'error', error_code: 'judgeme_endpoint' }, root);
        }).then(function () {
          state.loading = false; paint();
        });
      }
      function close() {
        if (!nodes) return;
        nodes.wrap.forEach(function (n) { if (n.parentNode) n.parentNode.removeChild(n); });
        nodes = null;
        document.documentElement.style.overflow = '';
        document.removeEventListener('keydown', onKey, true);
        if (ret && ret.focus) ret.focus();
      }
      function onKey(e) {
        if (!nodes) return;
        if (e.key === 'Escape') { e.preventDefault(); close(); return; }
        if (e.key === 'Tab') {
          var f = $$('button:not([hidden]),[tabindex="0"]', nodes.panel).filter(function (x) { return x.offsetParent !== null; });
          if (!f.length) return;
          var a = f[0], b = f[f.length - 1];
          if (e.shiftKey && document.activeElement === a) { e.preventDefault(); b.focus(); }
          else if (!e.shiftKey && document.activeElement === b) { e.preventDefault(); a.focus(); }
        }
      }
      openBtn.addEventListener('click', function () {
        if (nodes) return;
        ret = openBtn;
        var frag = tpl.content.cloneNode(true);
        var wrap = [].slice.call(frag.children);
        document.body.appendChild(frag);
        var panel = wrap.filter(function (n) { return n.tagName === 'ASIDE'; })[0];
        var loading = $('[data-h26-lyr-loading]', panel);
        nodes = {
          wrap: wrap, panel: panel,
          list: $('[data-h26-lyr-list]', panel),
          more: $('[data-h26-lyr-more]', panel),
          empty: $('[data-h26-lyr-empty]', panel),
          fail: $('[data-h26-lyr-fail]', panel),
          loadingText: loading ? loading.textContent : ''
        };
        document.documentElement.style.overflow = 'hidden';
        wrap.forEach(function (n) {
          n.addEventListener('click', function (e) { if (e.target.closest('[data-h26-lyr-close]')) close(); });
        });
        $$('.h26p-chips button', panel).forEach(function (c) {
          c.addEventListener('click', function () {
            state.filter = c.getAttribute('data-f');
            $$('.h26p-chips button', panel).forEach(function (x) { x.setAttribute('aria-pressed', String(x === c)); });
            paint();
            if (!state.failed && !state.done && state.filter !== 'all') {
              var vis = nodes.list.querySelectorAll('.h26p-rcard').length;
              if (vis < 3) load();
            }
          });
        });
        nodes.more.addEventListener('click', load);
        document.addEventListener('keydown', onKey, true);
        try { if (window.OOH26 && window.OOH26.observe) window.OOH26.observe(panel); } catch (e) {}
        var cb = $('.h26p-panel-h button', panel); if (cb) cb.focus();
        if (state.items.length || state.failed) paint(); else load();
      });
    });
  }

  /* ---------- sticky add to cart ---------- */
  // Bar and anchor are looked up on every check, so a bar or buy box swapped in later (bundle
  // variant picker, Oct 13) keeps working; oo_sticky_shown still fires once per page view.
  var stickyBound = false, stickyShown = false;
  function stickyAnchor() {
    return $('#h26p-main form[data-h26-atc]') || $('#h26p-main .h26p-notify') || $('#h26p-main .h26p-buybox');
  }
  function stickyCheck() {
    var bar = $('[data-h26-sticky]'), anchor = stickyAnchor();
    if (!bar || !anchor) return;
    var show = anchor.getBoundingClientRect().bottom < 60;
    if (getComputedStyle(bar).display === 'none') show = false;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', String(!show));
    $$('button', bar).forEach(function (b) { b.tabIndex = show ? 0 : -1; });
    if (show && !stickyShown) { stickyShown = true; track('sticky_shown', null, bar); }
  }
  function initSticky() {
    var bar = $('[data-h26-sticky]');
    if (!bar || bar.__h26) return;
    bar.__h26 = true;
    if (!stickyAnchor()) { bar.parentNode && bar.parentNode.removeChild(bar); return; }
    if (!stickyBound) {
      stickyBound = true;
      window.addEventListener('scroll', stickyCheck, { passive: true });
      window.addEventListener('resize', stickyCheck, { passive: true });
    }
    stickyCheck();
    var nb = $('[data-h26-sticky-notify]', bar);
    if (nb) nb.addEventListener('click', function () {
      var n = $('[data-h26-notify]');
      if (n) { scrollToEl(n); n.focus({ preventScroll: true }); }
    });
  }

  /* ---------- subscribe switch ---------- */
  function initSubscribe() {
    $$('[data-h26-sub]').forEach(function (root) {
      if (root.__h26) return; root.__h26 = true;
      var tg = $('[data-h26-sub-toggle]', root);
      var sel = $('[data-h26-sub-plan]', root);
      var freq = $('[data-h26-sub-freq]', root);
      if (!tg || !sel) return;
      var ship = $('#h26p-main .h26p-ship');
      var shipOnce = ship ? ship.innerHTML : null;
      var baseOnce = ship ? ship.getAttribute('data-h26-thr-gap') : null;
      var priceOnce = root.getAttribute('data-price-once') || '';
      function opt() { return sel.options[sel.selectedIndex] || sel.options[0]; }
      function apply() {
        var on = !!tg.checked, o = opt();
        $$('input[data-h26-sub-input]').forEach(function (i) { i.value = on && o ? o.value : ''; i.disabled = !on; });
        $$('[data-h26-sub-price]').forEach(function (el) { el.textContent = on && o ? o.getAttribute('data-price') : priceOnce; });
        if (freq) freq.hidden = !on || freq.hasAttribute('data-single');
        if (ship) {
          if (baseOnce !== null) {
            // converted currency: let h26-threshold.js paint the line again from the new basket
            ship.setAttribute('data-h26-thr-gap', on && o ? o.getAttribute('data-base') : baseOnce);
            if (window.H26Thr && window.H26Thr.apply) { ship.__h26thr = false; try { window.H26Thr.apply(ship); } catch (e) {} }
          } else if (o && o.getAttribute('data-ship')) {
            ship.innerHTML = on ? o.getAttribute('data-ship') : shipOnce;
          }
        }
      }
      tg.addEventListener('change', function () {
        var sw = $('.h26p-sw', root); if (sw) sw.classList.remove('nudge');
        apply();
        var o = opt();
        track('subscribe_toggle', { state: tg.checked ? 'on' : 'off', target: o ? o.value : null, variant_id: ($('#h26p-main form[data-h26-atc] input[name="id"]') || {}).value || null }, root);
      });
      sel.addEventListener('change', apply);
      var how = $('[data-h26-sub-how]', root);
      if (how) how.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var ex = document.getElementById(how.getAttribute('aria-controls'));
        if (!ex) return;
        ex.hidden = !ex.hidden;
        how.setAttribute('aria-expanded', String(!ex.hidden));
      });
      // a browser restoring the switch on back navigation keeps everything in step
      apply();
      if (!reduce && !tg.checked) {
        var sw = $('.h26p-sw', root);
        if (sw) setTimeout(function () { sw.classList.add('nudge'); setTimeout(function () { sw.classList.remove('nudge'); }, 3400); }, 1200);
      }
    });
  }

  /* ---------- Notify me (sold out) ---------- */
  function initNotify() {
    $$('[data-h26-notify]').forEach(function (b) {
      if (b.__h26) return; b.__h26 = true;
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-form-id');
        var fb = b.parentNode && $('[data-h26-notify-fallback]', b.parentNode);
        var ok = false;
        try {
          if (id && (window._klOnsite || window.klaviyo)) {
            window._klOnsite = window._klOnsite || [];
            window._klOnsite.push(['openForm', id]);
            ok = true;
          }
        } catch (e) {}
        if (!ok && fb) fb.hidden = false;
      });
    });
  }

  var once = false;
  // re-runnable for content added later (editor reloads, injected modules); every part is guarded
  function init() {
    var parts = [initGallery, initFarmer, initCarousels, initReviews, initNotify, initSubscribe, initSticky];
    if (!once) { once = true; parts = parts.concat([initJumps]); }
    parts.forEach(function (f) {
      try { f(); } catch (e) { try { console.warn('[h26-pdp]', f.name, e && e.message); } catch (x) {} }
    });
  }
  window.OOH26PDP = { init: init };
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
